import React from "react";

const ComeDownList = ({ listItem }) => {
  return <li>{listItem}</li>;
};

export default ComeDownList;
